import { Link, NavLink } from "react-router-dom";
import { Bath } from "lucide-react";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-bg/95 backdrop-blur border-b border-line"
    >
      <div className="container-x flex items-center justify-between h-16">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2.5 group"
        >
          <span className="w-9 h-9 grid place-items-center bg-brand text-white rounded-md transition-transform group-hover:rotate-[-4deg]">
            <Bath size={18} strokeWidth={2.25} />
          </span>
          <span className="font-display text-xl font-semibold tracking-tight">
            UpgradeCost
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <NavLink
            to="/"
            end
            data-testid="nav-home"
            className={({ isActive }) =>
              `text-ink-muted hover:text-ink transition ${isActive ? "text-ink" : ""}`
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/calculator"
            data-testid="nav-calculator"
            className={({ isActive }) =>
              `text-ink-muted hover:text-ink transition ${isActive ? "text-ink" : ""}`
            }
          >
            Calculator
          </NavLink>
          <NavLink
            to="/guides"
            data-testid="nav-guides"
            className={({ isActive }) =>
              `text-ink-muted hover:text-ink transition ${isActive ? "text-ink" : ""}`
            }
          >
            Cost guides
          </NavLink>
        </nav>

        <Link
          to="/calculator"
          data-testid="header-cta"
          className="btn-primary text-sm py-2.5 px-4"
        >
          Estimate my project
        </Link>
      </div>
    </header>
  );
}
